import PropTypes from "prop-types";
import React from "react";
import activeLikeIcon from "../../../assets/slider/activeLike.png";
import inactiveLikeIcon from "../../../assets/slider/inactiveLike@3x.png";
import "./styles.scss";

const LikeButton = ({ onClick, isActive = false }) => (
  <img
    className="card-button"
    onClick={onClick}
    src={isActive ? activeLikeIcon : inactiveLikeIcon}
    alt="❤"
  />
);

LikeButton.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default LikeButton;
